import { render, staticRenderFns } from "./NfeAttachments.vue?vue&type=template&id=c74fa2d2&scoped=true"
import script from "./NfeAttachments.vue?vue&type=script&lang=js"
export * from "./NfeAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74fa2d2",
  null
  
)

export default component.exports